import { render, staticRenderFns } from "./MailForClient.vue?vue&type=template&id=5a049229&scoped=true&"
import script from "./MailForClient.vue?vue&type=script&lang=js&"
export * from "./MailForClient.vue?vue&type=script&lang=js&"
import style0 from "./MailForClient.vue?vue&type=style&index=0&id=5a049229&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a049229",
  null
  
)

export default component.exports